export default "__VITE_ASSET__SK6TNNno__"